module.exports = __webpack_public_path__ + "img/missionaries12_2019_7-7-2021.13321393.jpg";